import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class DocumentViewerService {
	constructor(private http: HttpClient) {}

	// sign pdf
	OpenDoc(data) {
		return this.http.post('/api/document-viewer/OpenDoc', data);
	}

	SaveAsPdf(data) {
		return this.http.post('/api/document-viewer/SaveAsPdf', data);
	}

	SaveAsPdfMobile(data) {
		return this.http.post('/api/document-viewer/SaveAsPdfMobile', data);
	}

	Save(data) {
		return this.http.post('/api/document-viewer/Save', data);
	}

	SaveExcel(data) {
		return this.http.post('/api/document-viewer/SaveExcel', data);
	}

	GenerateExcelLink(data) {
		return this.http.post('/api/document-viewer/GenerateExcelLink', data);
	}

	OpenExcel(data) {
		return this.http.post('/api/document-viewer/OpenExcel', data);
	}

	GenerateLink(id) {
		return this.http.get(`/api/document-viewer/GenerateLink/${id}`);
	}
}
